(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('TypeTaxDeleteController',TypeTaxDeleteController);

    TypeTaxDeleteController.$inject = ['$uibModalInstance', 'entity', 'TypeTax'];

    function TypeTaxDeleteController($uibModalInstance, entity, TypeTax) {
        var vm = this;
        vm.typeTax = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TypeTax.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
